// See _theme.scss -> $ra-font-size
export const FontSize = {
	pageTitle: 'pageTitle', // 80px
	hero: 'hero', // 64px
	title: 'title', // 42px
	heading: 'heading', // 32px
	subtitle: 'subtitle', // 28px
	subheading: 'subheading', // 21px
	article: 'article', // 18px
	paragraph: 'paragraph', // 16px
	body: 'body', // 14px
	label: 'label', // 13px
	description: 'description', // 12px
	footnote: 'footnote', // 11px
} as const;

// See Text.scss -> $font-weight
export const FontWeight = {
	none: 'none',
	lighter: 'lighter',
	normal: 'normal',
	medium: 'medium',
	semibold: 'semibold',
	bold: 'bold',
	bolder: 'bolder',
} as const;

// See Text.scss -> $font-style
export const FontStyle = {
	none: 'none',
	normal: 'normal',
	italic: 'italic',
} as const;

export const TextTransform = {
	none: 'none',
	normal: 'normal',
	uppercase: 'uppercase',
	lowercase: 'lowercase',
	capitalize: 'capitalize',
} as const;

export const TextColor = {
	black: 'black',
	blackDark: 'black-dark',
	blackMid: 'black-mid',
	blackSoft: 'black-soft',
	blackLight: 'black-light',
	white: 'white',
	whiteDark: 'white-dark',
	whiteMid: 'white-mid',
	whiteSoft: 'white-soft',
	whiteLight: 'white-light',
	brand: 'brand',
	brandDark: 'brand-dark',
	brandLight: 'brand-light',
} as const;
